export default () => {
  const estateStyleLink = document.querySelectorAll('link[rel="stylesheet"]')[1];
  const estatePickers = Array.from(document.querySelectorAll('.estate-picker'));
  if (estatePickers.length) {
    const getDefaultEstate = () => {
      const currentEstate = estateStyleLink.getAttribute('href').match(/([a-z-]+)\.css/i)[1];
      const parsedQuery = location.hash.match(/\?estate=([a-z-]+)/i);
      return (parsedQuery && parsedQuery.length) >= 2 ? parsedQuery[1] : currentEstate;
    };

    const setEstateStyle = (estate) => {
      const currentEstate = estateStyleLink.getAttribute('href').match(/([a-z-]+)\.css/i)[1];
      const newStylePath = estateStyleLink.getAttribute('href').replace(/[a-z-]+\.css/gi, `${estate}.css`);
      if (currentEstate !== estate) {
        location.hash = `estate=${estate}`;
        estateStyleLink.setAttribute('href', newStylePath);
      }
    };

    const defaultEstate = getDefaultEstate();
    if (defaultEstate) {
      setEstateStyle(defaultEstate);
    }

    estatePickers.forEach((select) => {
      const $select = $(select);
      $(`option[value="${getDefaultEstate()}"]`, $select).attr('selected', true);
      $select.on('change', (e) => {
        e.preventDefault();
        const selectedEstate = $('option:selected', e.target).attr('value');
        setEstateStyle(selectedEstate);
      });
    });
  }
};
